import React, { useEffect } from "react";
import { decryptAndRetrieve } from "../../utils/user_data";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

export default function SuperAdminRoute({children}) {
  SuperAdminRoute.propTypes = {
    children:PropTypes.any
  };
  const navigate = useNavigate();
  const data = decryptAndRetrieve('bargo');

  useEffect(() => {
    if(data !== 'superadmin'){
      navigate('/');
      toast.warning('دسترسی غیرمجاز!')
    }
  }, [data]);
  return <>{children}</>;
}